<!--
 * @Author: guoyu
 * @Date: 2020-09-10 16:35:59
 * @LastEditors: your name
 * @LastEditTime: 2021-05-10 19:03:35
 * @Description: 陪玩基本信息
-->
<template>
  <div class="button-container">
    <div
      class="right-button"
       v-if="!isSelf"
      @click="handleReace"
      :class="{ 'is-reace': isReace }"
    >
      <fps-icon
        class="fllow-icon"
        :type="isReace ? 'followed' : 'add'"
        size="15"
      />
      {{ isReace ? '已追蹤' : '追蹤' }}
      <!-- <span class="fllow-num" v-if="playerInfo.follower">
        <i class="weight">{{ playerInfo.follower }}</i>
      </span> -->
    </div>
    <button class="right-button" @click="showShareDialog = true">
      <fps-icon class="share-icon" type="share" size="14" color="#636D86" />
      <span>分享</span>
    </button>
    <UserRelation
      v-if="!isSelf && userInfo"
      height="30px"
      :currentMasterId="playerInfo.uuid || ''"
    ></UserRelation>
    <ShareDialog
      :shareId="playerInfo.uuid"
      v-model="showShareDialog"
    ></ShareDialog>
  </div>
</template>
<script>
import { followUser } from '@/api/quick-order';
import Login from '@/components/Login/index';
import UserRelation from '@/components/UserRelation';
import ShareDialog from '@/components/FpsShare/index';
export default {
  components: {
    UserRelation,
    ShareDialog,
  },
  props: {
    playerInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fllowing: false,
      showShareDialog: false,
      showSendGift: false,
    };
  },
  computed: {
    isReace() {
      let status = this.playerInfo.followStatus;
      return status && status !== 'Unfollow';
    },
    sex() {
      let s = this.playerInfo.sex || '';
      return s.toLocaleLowerCase();
    }
  },
  methods: {
    sendGiftSuccess(gift) {
      this.showSendGift = false;
      this.$emit('sendgiftsuccess', gift);
    },
    goChat() {
      this.$adjust('web_personalpage_chat_btn_click');
      if (!this.userInfo || !this.userInfo.uuid) {
        Login().then(status => {
          if (!this.isSelf && status) {
            this.$util.openChatWindow(this.userInfo.uuid, this.playerInfo.uuid);
          }
        });
      } else {
        this.$util.openChatWindow(this.userInfo.uuid, this.playerInfo.uuid);
      }
    },
    async handleReace() {
      if (!this.userInfo || !this.userInfo.uuid) {
        let status = await Login().then(s => {
          return s;
        });
        if (!status) return;
      }
      let messageText = this.isReace ? '取消追蹤成功' : '追蹤成功';
      if (this.fllowing) return;
      let followOptType = this.isReace ? 'Unfollow' : 'Follow';
      followUser({
        followOptType,
        uuid: this.playerInfo.uuid
      })
        .then(rs => {
          this.fllowing = false;
          if (!rs.success) {
            console.error(rs.msg);
            this.$message.error('網絡忙');
            return;
          }
          let step = this.isReace ? -1 : 1;
          let num = this.playerInfo.follower + step;
          if (num < 0) {
            num = 0;
          }
          this.$set(this.playerInfo, 'follower', num);
          this.$set(this.playerInfo, 'followStatus', followOptType);
          this.$message({
            message: messageText,
            type: 'success'
          });
        })
        .catch(e => {
          this.fllowing = false;
          console.error(e);
          this.$message.error('網絡忙');
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 0 4px;
  border-top: 1px solid #f1f4f6;
}
.go-chat {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: 24px;
  right: 24px;
  height: 44px;
  padding: 0 24px;
  border: none;
  background: #fed838;
  border-radius: 26px;
  font-weight: 500;
  font-size: 16px;
  line-height: 44px;
  width: 150px;
  color: #222c43;
  cursor: pointer;
}
.message-icon {
  margin-right: 8px;
}
.right-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 50px;
  font-size: 12px;
  background: none;
  cursor: pointer;
  color: #636d86;
  white-space: nowrap;
  &:hover {
    background: #f1f4f6;
  }
}
.is-reace {
  color: rgba(140, 148, 170, 0.8);
}
.fllow-icon {
  margin-right: 4px;
}
.fllow-num {
  margin-left: 4px;
}
.share-icon {
  margin-right: 4px;
}
</style>
